import { FC, useCallback, useState } from "react";
import { WithStyle } from "utils/WithStyle";
import { SearchBarWrapper, SearchIcon, SearchInput } from "./Searchbar.styled";
import { FiSearch } from "react-icons/fi";
import { BiChevronDown } from "react-icons/bi";
import { SearchBarTypes } from "./types";

const Component: FC<SearchBarTypes> = ({
    variant = "compact",
    onInputChange,
    onClear,
    onSearch,
}) => {
    const [searchInput, setSearchInput] = useState("");

    const handleSearchInputChange = useCallback(
            (e: any) => {
                const { value } = e.target;

                if (value === "") {
                    onClear && onClear();
                }

                setSearchInput(value);
                onInputChange && onInputChange(value);
            },
            [onClear, onInputChange]
        ),
        handleSearch = useCallback(
            (e: any) => {
                e.preventDefault();
                onSearch && onSearch(searchInput);
            },
            [onSearch, searchInput]
        );

    return (
        <SearchBarWrapper variant={variant} onSubmit={handleSearch}>
            <FiSearch color="#434343" id="search-bar-compact-search-icon" />
            <SearchInput
                type="text"
                placeholder="Search..."
                value={searchInput}
                onChange={handleSearchInputChange}
            />
            <BiChevronDown
                color="#434343"
                id="search-bar-compact-options-icon"
            />
            <SearchIcon type="submit">
                <FiSearch color="#fff" fontWeight={600} />
            </SearchIcon>
        </SearchBarWrapper>
    );
};

export const SearchBar: FC<SearchBarTypes> & WithStyle = Object.assign(
    Component,
    {
        Style: SearchBarWrapper,
    }
);
